import React from "react";

const CategoriyHolder = ({ category }) => (
    <p className="font-bold rounded-3 px-3 py-1" style={{ backgroundColor: `${category.color}20`, color: category.color }}>
        {category.text}
    </p>
);
export default CategoriyHolder;
